import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom/client";

const Slider = (slides) => {
    if (slides.slides) {
        slides = slides.slides;
    }

    const [current, setCurrent] = useState(0);
    const intervalRef = useRef(null);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);
    const INTERVAL_TIME = 9000;

    // Set up interval for auto-slide
    useEffect(() => {
        startInterval();

        return () => clearIntervalIfAny();
        // eslint-disable-next-line
    }, []);

    // Helper to clear interval
    function clearIntervalIfAny() {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }

    // Helper to set up/restart interval
    function startInterval() {
        clearIntervalIfAny();
        intervalRef.current = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, INTERVAL_TIME);
    }

    // Touch event handlers for mobile
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };
    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].clientX;
        handleSwipe();
    };
    const handleSwipe = () => {
        const swipeDistance = touchStartX.current - touchEndX.current;
        const swipeThreshold = 50;

        if (swipeDistance > swipeThreshold) {
            setCurrent((prev) => (prev + 1) % slides.length);
            startInterval(); // restart interval after swipe
        } else if (swipeDistance < -swipeThreshold) {
            setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
            startInterval(); // restart interval after swipe
        }
    };


    // Handle dot click: set slide and clear auto-slide
    const handleDotClick = (index) => {
        setCurrent(index);
        startInterval();
    };




    return (
        <section>
            <div class="max-md:hidden md:block sm:hidden lg:block h-[100vh] md:h-[60vh] lg:h-[80vh] xl:h-[80vh]">

                <div class="relative w-full mx-auto overflow-hidden">

                    <div
                        class="flex transition-transform duration-700 ease-in-out"
                        style={{ transform: `translateX(-${current * 100}%)` }}
                    >
                        {slides.map((slide) => (
                            <section
                                key={slide.id}
                                class="min-w-full flex flex-col md:flex-row items-center md:items-start pad-t-40 md:pad-t-85 lg:pad-t-85 xl:pad-t-85 
      mb-20 md:mb-20 lg:mb-20 xl:mb-20"
                            >
                                {/* Left Image */}
                                <div class="flex  
            sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2
            pad-l-10 md:pad-l-100 lg:pad-l-100 xl:pad-l-250 pad-r-15 rounded-xl! 
            justify-items-end float-right">
                                    <img src={slide.image} alt={slide.title} class="rounded-xl! h-[70vh] md:h-[30vh] lg:h-[33vh] xl:h-[70vh]" />
                                </div>

                                <div class="w-full md:w-1/2 text-left items-center justify-left flex flex-col 
      pad-t-5 md:pad-t-20 lg:pad-t-50 xl:pad-t-50
      pad-r-20">
                                    <p class={`
                                    font-Unbounded text-primary mx-auto lh-1_2
                                    text-4xl sm:text-[3vw] lg:text-[3vw] xl:text-[3.5vw]
                                    font-bold sm:font-bold lg:font-[700] xl:font-bold 
                pad-l-20 md:pad-l-20 lg:pad-l-20 xl:pad-l-20
                pad-r-20 md:pad-r-50 lg:pad-r-50 xl:pad-r-50
                w-full md:w-full lg:w-full xl:w-[80%]`}
                                    >
                                        {slide.title}
                                    </p>
                                    <p class="text-primary mt-4 text-l font-worksans pad-b-25
                      pad-l-20 md:pad-l-20 lg:pad-l-20 xl:pad-l-20
                      pad-r-20 md:pad-r-50 lg:pad-r-50 xl:pad-r-50
                      text-[5vw] md:text-[2vw] lg:text-[1vw]
                      w-full md:w-full lg:w-full xl:w-[80%]">{slide.description}</p>
                                </div>
                            </section>
                        ))}
                    </div>

                    <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 
    pad-t-25 md:pad-t-50 lg:pad-t-100 xl:pad-t-150">
                        {slides.map((_, index) => (
                            <div
                                key={index}
                                class={`h-2 w-9 rounded-full mr-[0.8rem] cursor-pointer ${current === index ? "bg-primary" : "bg-gray-300"
                                    }`}
                                onClick={() => handleDotClick(index)} // ← Click event to switch slide
                            />
                        ))}
                    </div>

                </div>

            </div>



            <div class="mx-auto md:hidden max-sm:block lg:hidden
            h-[100vh] md:h-[60vh] lg:h-[80vh] xl:h-[80vh]"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
                id="sliderContainer">

                <div class="relative w-full mx-auto overflow-hidden">

                    <div
                        class="flex transition-transform duration-700 ease-in-out"
                        style={{ transform: `translateX(-${current * 100}%)` }}
                    >
                        {slides.map((slide) => (
                            <section
                                key={slide.id}
                                class="min-w-full flex flex-col md:flex-row items-center md:items-start pad-t-40 md:pad-t-85 lg:pad-t-85 xl:pad-t-85 
pad-b-5 md:pad-b-20 lg:pad-b-50 xl:pad-b-50"
                            >


                                <div class="w-full md:w-1/2 text-left items-center justify-left flex flex-col 
pad-t-5 md:pad-t-20 lg:pad-t-50 xl:pad-t-50
pad-r-20">
                                    <p class={`font-Unbounded font-semibold text-primary lh-1_2
    text-2xl md:text-2xl lg:text-4xl xl:text-4xl 
    pad-l-20 md:pad-l-50 lg:pad-l-50 xl:pad-l-50
    pad-r-20 md:pad-r-50 lg:pad-r-50 xl:pad-r-50
    w-full md:w-full pt-5 lg:w-full xl:w-[80%]`}
                                    >
                                        {slide.title}
                                    </p>
                                    <p class="md:pad-1 text-primary mt-4 text-l font-worksans pad-b-25
          pad-l-20 md:pad-l-50 lg:pad-l-50 xl:pad-l-50
          pad-r-20 md:pad-r-50 lg:pad-r-50 xl:pad-r-50
          text-[5vw] md:text-[2vw] lg:text-[1vw]
          w-full md:w-full lg:w-full xl:w-[80%] mb-10">{slide.description}</p>
                                </div>
                                {/* Left Image */}
                                <div class="flex  
sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2
pad-l-10 md:pad-l-100 lg:pad-l-100 xl:pad-l-250 pad-r-15 mb-10">
                                    {slide.id === 10 ? (
                                        <div class="
    hexagon
    bg-[url(flexbag-magnatic-fasteners.gif)] bg-cover bg-no-repeat bg-center
  w-[320px] md:w-[600px] lg:w-[800px] xl:w-[850px]
   h-[320px] md:h-[350px] lg:h-[500px] xl:h-[600px]
    "></div>
                                    ) : (
                                        <img src={slide.image} alt={slide.title} class="rounded-xl! h-[44vh] md:h-[30vh] lg:h-[33vh] xl:h-[70vh]" />
                                    )}
                                </div>
                            </section>
                        ))}
                    </div>

                    <div class="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex space-x-2 
mt-10 md:pad-t-50 lg:pad-t-100 xl:pad-t-150">
                        {slides.map((_, index) => (
                            <div
                                key={index}
                                class={`h-2 w-9 rounded-full mr-[0.8rem] cursor-pointer ${current === index ? "bg-primary" : "bg-gray-300"
                                    }`}
                                onClick={() => handleDotClick(index)} // ← Click event to switch slide


                            />
                        ))}
                    </div>

                </div>

            </div>
        </section>

    );
};

// Function to extract translated slides from DOM
function getTranslatedSlidesFromDOM(elementId) {
    const controlId = `#${elementId}-translated-slides .slide-data`;
    console.log("controlId: ", controlId);
    // const controlId = `#${elementId} .slide-data`;
    const elements = document.querySelectorAll(controlId);
    console.log("elements: ", elements);
    if (elements.length === 0) {
        console.error("No translated slides found in the DOM.");
        // return [];
    }
    const slides = [];

    elements.forEach((el) => {
        slides.push({
            id: el.dataset.id,
            title: el.querySelector(".weg-slide-title").innerText,
            description: el.querySelector(".weg-slide-description").innerText,
            image: el.dataset.image,
            fontColor: el.dataset.fontcolor,
        });
    });

    return slides;
}

// ✅ Render React Component in Liquid File
// Render React Component in Liquid File
window.renderFlexbagSlider = (elementId) => {
    console.log("renderFlexbagSlider called with elementId: ", elementId);
    const rootEl = document.getElementById(elementId);
    if (rootEl) {
        const slides = getTranslatedSlidesFromDOM(elementId);
        ReactDOM.createRoot(rootEl).render(<Slider slides={slides} />);
    }
};


